import React from "react";
import { Route, Routes } from "react-router-dom";
import DashboardLayout from "@/layouts/DashboardLayout";
import { LayoutDashboard, Users, ClipboardList, MapPin } from "lucide-react";
import ManagerOverview from "@/pages/manager/Overview";
import ManagerExecutives from "@/pages/manager/ExecutivesManage";
import LeadsPage from "@/pages/shared/LeadsPage";
import ManagerTerritory from "@/pages/manager/TerritoryView";

const NAV = [
  { to: "/manager", key: "dashboard", icon: LayoutDashboard, end: true, label: "Dashboard" },
  { to: "/manager/executives", key: "executives", icon: Users, label: "Executives" },
  { to: "/manager/leads", key: "leads", icon: ClipboardList, label: "Leads" },
  { to: "/manager/territory", key: "territory", icon: MapPin, label: "Territory" },
];

export default function ManagerDashboard() {
  return (
    <Routes>
      <Route element={<DashboardLayout title="MANAGER" nav={NAV} testIdPrefix="manager-nav" />}>
        <Route index element={<ManagerOverview />} />
        <Route path="executives" element={<ManagerExecutives />} />
        <Route path="leads" element={<LeadsPage role="manager" />} />
        <Route path="territory" element={<ManagerTerritory />} />
      </Route>
    </Routes>
  );
}
